import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DashbardNavComponent } from "./dashbard-nav.component";

@NgModule({
  declarations: [DashbardNavComponent],
  imports: [CommonModule],
  exports: [DashbardNavComponent]
})
export class DashbardNavModule {}
